import { Injector } from '@angular/core';
import { EIremboFormlyFieldTypes } from '@irembo-andela/irembogov3-common';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { BaseFormlyFieldConfiguration } from '../base-formly-field-configuration';
import { CheckboxFormlyFieldConfiguration } from '../checkbox-formly-field-configuration';
import { CustomApplicationNumberInputFormlyFieldConfiguration } from '../custom-application-number-input-formly-field-configuration';
import { CustomCascadingDropdownsFormlyFieldConfiguration } from '../custom-cascading-dropdowns-formly-field-configuration';
import { CustomCRVSIdInputFormlyFieldConfiguration } from '../custom-crvs-id-input-formly-field-configuration';
import { CustomDataTableFormlyFieldConfiguration } from '../custom-data-table-formly-field-configuration';
import { CustomDatasetTableFormlyFieldConfiguration } from '../custom-dataset-table-formly-field-configuration';
import { CustomDatePickerFormlyFieldConfiguration } from '../custom-date-picker-formly-field-configuration';
import { CustomDateTimePickerFormlyFieldConfiguration } from '../custom-date-time-picker-formly-field-configuration';
import { CustomDoubleIdInputFormlyFieldConfiguration } from '../custom-double-id-input-formly-field-configuration';
import { CustomDropdownFormlyFieldConfiguration } from '../custom-dropdown-formly-field-configuration';
import { CustomDropdownPaginatedFormlyFieldConfiguration } from '../custom-dropdown-paginated-formly-field-configuration';
import { CustomDynamicRepeaterFormlyFieldConfiguration } from '../custom-dynamic-repeater-formly-field-configuration';
import { CustomErrorComponentFormlyFieldConfiguration } from '../custom-error-component-formly-field-configuration';
import { CustomFileUploadFormlyFieldConfiguration } from '../custom-file-upload-formly-field-configuration';
import { CustomGenericDataFetchFormlyFieldConfiguration } from '../custom-generic-data-fetch-formly-field-configuration';
import { CustomSectionMessageWithLinkFormlyFieldConfiguration } from '../custom-section-message-with-link-formly-field-configuration';
import { CustomTinInputFormlyFieldConfiguration } from '../custom-tin-input-formly-field-configuration';
import { InputFormlyFieldConfiguration } from '../input-formly-field-configuration';
import { InternationalPhoneNumberFormlyFieldConfiguration } from '../international-phone-number-formly-field-configuration';
import { MultiCheckboxFormlyFieldConfiguration } from '../multi-checkbox-formly-field-configurattion';
import { NIDFormlyFieldConfiguration } from '../nid-formly-field-configuration';
import { RadioFormlyFieldConfiguration } from '../radio-formly-field-configuration';
import { SlotBookingFormlyFieldConfiguration } from '../slot-booking-formly-field-configuration';
import { TextareaFormlyFieldConfiguration } from '../textarea-formly-field-configuration';
import { CustomTimePickerFormlyFieldConfiguration } from '../custom-time-picker-formly-field-configuration';
import { CurrencyFormatInputFormlyFieldConfiguration } from '../custom-currency-format-field-configuration';
import { CustomOtpDataFetchFormlyFieldConfiguration } from '../custom-otp-data-fetch-formly-field-configuration';
import { CustomRepeaterFormlyFieldConfiguration } from '../custom-repeater-formly-field-configuration';
import { CustomTableWithInputFormlyFieldConfiguration } from '../custom-table-with-input-formly-field-configuration';
import {
  ADVANCED_FORM_FIELD_TYPES,
  AdvancedFormlyFieldConfiguration,
} from '../advanced-formly-field-configuration';

export const getFormFieldConfigurationClass = (
  injector: Injector,
  field: FormlyFieldConfig
): BaseFormlyFieldConfiguration => {
  if (
    ADVANCED_FORM_FIELD_TYPES.includes(field?.type as EIremboFormlyFieldTypes)
  ) {
    return new AdvancedFormlyFieldConfiguration(injector, field);
  }

  switch (field?.type) {
    case EIremboFormlyFieldTypes.checkbox:
      return new CheckboxFormlyFieldConfiguration(injector, field);
    case EIremboFormlyFieldTypes.input:
      return new InputFormlyFieldConfiguration(injector, field);
    case EIremboFormlyFieldTypes.textarea:
      return new TextareaFormlyFieldConfiguration(injector, field);
    case EIremboFormlyFieldTypes.customdropdown:
      return new CustomDropdownFormlyFieldConfiguration(injector, field);
    case EIremboFormlyFieldTypes.customdropdownpaginated:
      return new CustomDropdownPaginatedFormlyFieldConfiguration(
        injector,
        field
      );
    case EIremboFormlyFieldTypes.multicheckbox:
      return new MultiCheckboxFormlyFieldConfiguration(injector, field);
    case EIremboFormlyFieldTypes.radio:
      return new RadioFormlyFieldConfiguration(injector, field);
    case EIremboFormlyFieldTypes.customidinput:
      return new NIDFormlyFieldConfiguration(injector, field);
    case EIremboFormlyFieldTypes.customphonenumber:
      return new InternationalPhoneNumberFormlyFieldConfiguration(
        injector,
        field
      );
    case EIremboFormlyFieldTypes.customdatepicker:
      return new CustomDatePickerFormlyFieldConfiguration(injector, field);
    case EIremboFormlyFieldTypes.customfileupload:
      return new CustomFileUploadFormlyFieldConfiguration(injector, field);
    case EIremboFormlyFieldTypes.customcascadingdropdowns:
      return new CustomCascadingDropdownsFormlyFieldConfiguration(
        injector,
        field
      );
    case EIremboFormlyFieldTypes.customslotbooking:
      return new SlotBookingFormlyFieldConfiguration(injector, field);
    case EIremboFormlyFieldTypes.customtininput:
      return new CustomTinInputFormlyFieldConfiguration(injector, field);
    case EIremboFormlyFieldTypes.customcrvsidinput:
      return new CustomCRVSIdInputFormlyFieldConfiguration(injector, field);
    case EIremboFormlyFieldTypes.customgenericdatafetch:
      return new CustomGenericDataFetchFormlyFieldConfiguration(
        injector,
        field
      );
    case EIremboFormlyFieldTypes.customapplicationnumberinput:
      return new CustomApplicationNumberInputFormlyFieldConfiguration(
        injector,
        field
      );
    case EIremboFormlyFieldTypes.customsectionmessagewithlink:
      return new CustomSectionMessageWithLinkFormlyFieldConfiguration(
        injector,
        field
      );
    case EIremboFormlyFieldTypes.customdoubleidinput:
      return new CustomDoubleIdInputFormlyFieldConfiguration(injector, field);
    case EIremboFormlyFieldTypes.customdatasettable:
      return new CustomDatasetTableFormlyFieldConfiguration(injector, field);
    case EIremboFormlyFieldTypes.customdatatable:
      return new CustomDataTableFormlyFieldConfiguration(injector, field);
    case EIremboFormlyFieldTypes.customdynamicrepeater:
      return new CustomDynamicRepeaterFormlyFieldConfiguration(injector, field);
    case EIremboFormlyFieldTypes.customdatetimepicker:
      return new CustomDateTimePickerFormlyFieldConfiguration(injector, field);
    case EIremboFormlyFieldTypes.customerrorcomponent:
      return new CustomErrorComponentFormlyFieldConfiguration(injector, field);
    case EIremboFormlyFieldTypes.customtimepicker:
      return new CustomTimePickerFormlyFieldConfiguration(injector, field);
    case EIremboFormlyFieldTypes.customcurrencyformatinput:
      return new CurrencyFormatInputFormlyFieldConfiguration(injector, field);
    case EIremboFormlyFieldTypes.customotpdatafetch:
      return new CustomOtpDataFetchFormlyFieldConfiguration(injector, field);
    case EIremboFormlyFieldTypes.customrepeater:
      return new CustomRepeaterFormlyFieldConfiguration(injector, field);
    case EIremboFormlyFieldTypes.customtablewithinputform:
      return new CustomTableWithInputFormlyFieldConfiguration(injector, field);
    default:
      return new BaseFormlyFieldConfiguration(injector, field);
  }
};
